import * as z from "zod";
import { null as zNull } from "zod";
import { marketWithCountriesOutput } from "./redo-market";

/** All cross-border markets configured for the authenticated team, each with
 * its per-country publish targets. */
export const getRedoMarkets = {
  name: "getRedoMarkets" as const,
  input: zNull(),
  output: z.object({ markets: z.array(marketWithCountriesOutput) }),
};
